/**
 * Subscription configuration for frontend.
 * This file contains configuration for Stripe integration.
 */

// Stripe configuration
export const STRIPE_CONFIG = {
  // This should be set in your environment variables
  PUBLISHABLE_KEY: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || '',

  // API endpoints
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000',

  // Subscription endpoints
  ENDPOINTS: {
    SUBSCRIPTION: '/api/subscriptions/me',
    CHECKOUT: '/api/subscriptions/checkout',
    PAYMENT_INTENT: '/api/subscriptions/create-payment-intent',
  },
} as const;

// Export for easy access
export const subscriptionConfig = STRIPE_CONFIG;

// Subscription plans (if you want to display them)
export const SUBSCRIPTION_PLANS = {
  FREE: {
    name: 'Free',
    price: 0,
    features: ['Basic AI companions', 'Limited conversations', 'Community support'],
  },
  PREMIUM: {
    name: 'Premium',
    price: 9.99,
    features: [
      'All AI companions',
      'Unlimited conversations',
      'Priority support',
      'Advanced features',
    ],
  },
} as const;

// Validation
export const validateStripeConfig = (): boolean => {
  return !!STRIPE_CONFIG.PUBLISHABLE_KEY;
};

// Get full API URL
export const getApiUrl = (endpoint: string): string => {
  return `${STRIPE_CONFIG.API_BASE_URL}${endpoint}`;
};
